import axios from './axios.service'

const method = 'trainings'

class TrainingService {
  async getAll(queryData) {
    try {
      const response = await axios.get(`/${method}`, {
        params: { ...queryData }
      })
      return response.data
    } catch (error) {
      return error
    }
  }

  async getTrainingInformation(id) {
    try {
      const response = await axios({
        method: 'get',
        url: `/${method}/${id}`
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async deleteTraining(rowClicked) {
    try {
      const response = await axios.delete(`/${method}/${rowClicked.id}`)
      return response
    } catch (error) {
      return error
    }
  }

  async storeTraining(data) {
    try {
      const response = await axios({
        method: 'post',
        url: `/${method}`,
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async updateTraining(id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `/${method}/${id}`,
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }
}

export default new TrainingService()
